import notification from 'app/config/notification';
import { FILE_ALLOWED_EXTENSIONS, FILE_MAX_SIZE } from 'app/utils/constants';

export const validateFile = (files, intl) => {
  let tempFileName = files[0].name;
  let ext = tempFileName.split('.').pop();
  ext = ext.toLowerCase();

  if (files[0].size > FILE_MAX_SIZE) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.FILE_MAX_SIZE' }), {
      toastId: 'FILE_MAX_SIZE',
      type: 'error',
    });
    return false;
  }

  if (!FILE_ALLOWED_EXTENSIONS.includes(ext)) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.FILE_EXTENTION_NOT_ALLOWED' }), {
      toastId: 'ERROR_UPLOAD',
      type: 'error',
    });
    return false;
  }

  return true;
};

export const fixedDocumentName = (name) => {
  let nameSplitted = name.split('.');
  //FIXING EXTENTION
  if(nameSplitted.length > 1){
    let ext = nameSplitted.pop();
    ext = ext.toLowerCase();
    nameSplitted.push(ext);
  }
  //FIXING NAME
  nameSplitted = nameSplitted.map(name => {
    const tempName = name.replace(/[\\/:;*<>|?]/gi, '');
    return tempName;
  }); 
  let newName = nameSplitted.join('.');
  return newName;
}
